(() => {
  const shopifyLocationIdToCode = {
    81110106327: "dope",
    89325600983: "gastown",
    // add more as you capture them:
    // 0: "gnw",
    // 0: "central",
    // 0: "polygon",
    // 0: "tricity",
  };

  function pickupTaggedLineItems() {
    const rows = Array.from(document.querySelectorAll("tr.cart-item[data-key]"));
    return rows
      .map((row) => {
        const key = row.getAttribute("data-key");
        const tags = Array.from(row.querySelectorAll("[data-pickup-tag]")).map(
          (s) => s.dataset.pickupTag
        );
        return { key, tags };
      })
      .filter((x) => x.key && x.tags && x.tags.length > 0);
  }

  function invalidKeysFor(code) {
    const required = `pickup:${code}`;
    return pickupTaggedLineItems()
      .filter((li) => !li.tags.includes(required))
      .map((li) => li.key);
  }

  async function removeKeys(keys) {
    const updates = {};
    for (const k of keys) updates[k] = 0;

    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
    });

    location.reload();
  }

  function ensureBanner(locationLabel, badKeys) {
    const btn = document.querySelector("#checkout");
    if (btn) btn.disabled = true;

    let wrap = document.querySelector("#pickup-guard-message");
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.id = "pickup-guard-message";
      wrap.style.marginTop = "12px";
      wrap.style.padding = "12px";
      wrap.style.border = "1px solid rgba(0,0,0,.15)";
      wrap.style.borderRadius = "8px";
      wrap.style.fontSize = "14px";

      const host =
        document.querySelector("#cart-errors") || btn?.parentElement || document.body;
      host.appendChild(wrap);
    }

    const titles = badKeys.map((key) => {
      const row = document.querySelector(`tr.cart-item[data-key="${CSS.escape(key)}"]`);
      const titleEl = row?.querySelector(".cart-item__name");
      return (titleEl?.textContent || "").trim() || "Item";
    });

    wrap.innerHTML = `
      <div style="font-weight:600; margin-bottom:8px;">
        The following item(s) are not available at ${locationLabel}:
      </div>
      <ul style="margin: 0 0 10px 18px; padding:0;">
        ${titles.map((t) => `<li>${t}</li>`).join("")}
      </ul>
    `;

    const b = document.createElement("button");
    b.type = "button";
    b.textContent = `Remove ${badKeys.length} invalid item(s)`;
    b.style.marginTop = "6px";
    b.className = "button";
    b.addEventListener("click", () => removeKeys(badKeys));
    wrap.appendChild(b);
  }

  function clearBannerIfOk() {
    const btn = document.querySelector("#checkout");
    if (btn) btn.disabled = false;
    const wrap = document.querySelector("#pickup-guard-message");
    if (wrap) wrap.remove();
  }

  async function getShopifyLocationId() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    const cart = await res.json();
    const attrs = cart.attributes || {};
    const raw =
      attrs.shopifyLocationId ??
      attrs.shopify_location_id ??
      attrs.shopifyLocationID;

    if (raw == null) return null;

    const idNum = Number(String(raw).trim());
    return Number.isFinite(idNum) ? idNum : null;
  }

  function enforceWithLocId(locId) {
    const tagged = pickupTaggedLineItems();
    if (tagged.length === 0) {
      clearBannerIfOk();
      return true;
    }

    if (!locId) return false;

    const code = shopifyLocationIdToCode[locId] || null;
    if (!code) return true;

    const badKeys = invalidKeysFor(code);
    if (!badKeys.length) {
      clearBannerIfOk();
      return true;
    }

    ensureBanner(code, badKeys);
    return true;
  }

  let burstInFlight = false;
  let lastBurstAt = 0;

  async function burstEnforce({ maxTries = 12, intervalMs = 500 } = {}) {
    const now = Date.now();
    if (burstInFlight) return;
    if (now - lastBurstAt < 2000) return;

    burstInFlight = true;
    lastBurstAt = now;

    try {
      let stableCount = 0;
      let lastLocId = null;

      for (let i = 0; i < maxTries; i++) {
        const locId = await getShopifyLocationId().catch(() => null);

        if (locId && locId === lastLocId) stableCount += 1;
        else stableCount = 0;

        lastLocId = locId;

        const done = enforceWithLocId(locId);

        if (locId && stableCount >= 2 && done) break;

        await new Promise((r) => setTimeout(r, intervalMs));
      }
    } finally {
      burstInFlight = false;
    }
  }

  burstEnforce();

  const origFetch = window.fetch;
  let hookTimer = null;

  window.fetch = async (...args) => {
    const res = await origFetch(...args);

    try {
      const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
      if (
        url.includes("/cart/update.js") ||
        url.includes("/cart/change.js") ||
        url.includes("/cart/add.js")
      ) {
        if (hookTimer) clearTimeout(hookTimer);
        hookTimer = setTimeout(() => burstEnforce(), 300);
      }
    } catch (e) {}

    return res;
  };
})();